import { ValidationError } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/ValidatorError';
import { Validator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/Validator';
export class SendMessageFromHttpActionSettingsValidator extends Validator {
    validate(model) {
        if (!model.type) {
            throw new ValidationError('The HTTP message content type is required');
        }
        if (!model.uri) {
            throw new ValidationError('The HTTP message URI is required');
        }
        if (!model.uri.match(/^((http|https):\/\/[^ "]+|\{\{[A-Za-z0-9\.@\[\]]+\}\}[^ "]*)$/)) {
            throw new ValidationError('The specified HTTP message URI is invalid');
        }
    }
}
